import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { Angulartics2Module } from 'angulartics2';

import { AuthHttpInterceptor } from './auth-http-interceptor.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Angulartics2Module,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
